export interface RedeemPixPayload {
  id?: string;
  qr_code?: string;
  qr_code_url?: string;
  expires_at?: string;
  status?: string;
  [key: string]: unknown;
}

export interface RedeemWalletResultLike {
  status?: string | null;
  checkout?: RedeemPixPayload | { url?: string } | null;
}

export type RedeemOutcome =
  | { action: 'completed' }
  | { action: 'redirect'; url: string }
  | { action: 'pix'; pix: RedeemPixPayload }
  | { action: 'error' };

/**
 * Maps a redeemWalletForPlan mutation result to the UI action that settles it.
 * A PIX payload (qr_code) wins over a redirect URL: the QR flow is in-app and
 * never loses the user to a navigation.
 */
export function resolveRedeemOutcome(result: RedeemWalletResultLike | null | undefined): RedeemOutcome {
  if (!result) return { action: 'error' };

  if (result.status === 'completed') return { action: 'completed' };

  if (result.status === 'awaiting_remainder') {
    const checkout = result.checkout as RedeemPixPayload | null | undefined;
    if (checkout && typeof checkout.qr_code === 'string' && checkout.qr_code) {
      return { action: 'pix', pix: checkout };
    }
    if (checkout && typeof checkout.url === 'string' && checkout.url) {
      return { action: 'redirect', url: checkout.url };
    }
  }

  return { action: 'error' };
}
